import { BASE_URL, TOKEN } from "@/utils/const";

// Strapi v5 — fields are flat on the item, no nested `attributes`
type StrapiItem<T> = { id: number; documentId?: string } & T;
type StrapiSingleEnvelope<T> = { data: StrapiItem<T> };
type StrapiCollectionEnvelope<T> = { data: StrapiItem<T>[] };

export type StrapiEntity<T> = T & { strapiId: number };

function flatten<T>(item: StrapiItem<T>): StrapiEntity<T> {
	const { id, documentId, ...fields } = item as {
		id: number;
		documentId?: string;
	} & Record<string, unknown>;
	return { strapiId: id, ...fields } as StrapiEntity<T>;
}

async function strapiRequest<T>(path: string): Promise<T> {
	const headers: HeadersInit = { "Content-Type": "application/json" };
	if (TOKEN) headers["Authorization"] = `Bearer ${TOKEN}`;

	const res = await fetch(`${BASE_URL}/api${path}`, { headers });
	if (!res.ok) throw new Error(`Strapi ${res.status}: ${res.statusText}`);
	return res.json() as Promise<T>;
}

export async function strapiGetSingle<T>(
	path: string,
): Promise<StrapiEntity<T>> {
	const json = await strapiRequest<StrapiSingleEnvelope<T>>(path);
	return flatten(json.data);
}

export async function strapiGetCollection<T>(
	path: string,
): Promise<StrapiEntity<T>[]> {
	const json = await strapiRequest<StrapiCollectionEnvelope<T>>(path);
	return json.data.map(flatten);
}
